module.exports = __webpack_public_path__ + "static/media/amazon.d31c0da7.svg";